import { HttpClient } from '@angular/common/http';
import { StateKey, TransferState, makeStateKey } from '@angular/core';
import { SvgLoader } from 'angular-svg-icon';
import { Observable, tap } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

export class SvgBrowserLoader implements SvgLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly transferState: TransferState,
    private readonly platformId: string,
    private readonly iconsPath: string
  ) {}

  getSvg(url: string): Observable<string> {
    if (isPlatformBrowser(this.platformId)) {
      const key: StateKey<string> = makeStateKey<string>('transfer-svg:' + url);
      const data = this.transferState.get(key, null);

      if (data) {
        return new Observable((observer) => {
          observer.next(data);
          observer.complete();
        });
      } else {
        const correctedUrl = this.iconsPath + '/' + url;
        return this.http.get(correctedUrl, { responseType: 'text' }).pipe(
          tap((response) => {
            this.transferState.set(key, response);
          })
        );
      }
    } else {
      return new Observable((observer) => {
        observer.next('');
        observer.complete();
      });
    }
  }
}
